import SelectWeex from "./SelectWeex";
import LabelWeex from "./LabelWeex";
import {ElementStyles} from "./ElementStyles";

const styles={
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    width: "100%"
  },
  container: {
    borderRadius: ElementStyles.borderRadius,
    boxSizing: "inherit",
    color: ElementStyles.color,
    padding: ElementStyles.paddingLabels,
    // height: ElementStyles.height,
    display: "flex",
    alignItems: "center",
    paddingRight: 0
  }
}
export default function Select2Weex({label, options, defaultInputValue, onChange, placeholder, isMulti, containerStyle, value, ...props}){

  return (
    <LabelWeex style={{...styles.container, ...containerStyle}} {...props}>
      <div style={styles.grid}>
        <div style={{...styles.container, ...containerStyle, ...{paddingLeft: 0}}}>
          {label}
        </div>
        <SelectWeex options={options}
                    onChange={onChange}
                    placeholder={placeholder}
                    defaultInputValue={defaultInputValue}
                    isMulti={isMulti}
                    value={value}
                    containerStyle={{
                      paddingLeft:0,
                      paddingTop:0,
                      paddingBottom:0,
                      marginTop: "auto",
                      marginBottom: "auto"
                    }}
        />
      </div>
    </LabelWeex>
  );
};

